import { create } from "zustand";
import {
  ChatResponse,
  MessageContent,
} from "@aichat/types/socket/widget.types";
import { UserConversationRoleEnum } from "@aichat/types/enums/index";
import { formatISO } from "date-fns";

export const defaultMessageContent: MessageContent = {
  role: UserConversationRoleEnum.BOT,
  content: {
    text: "",
  },
  createdAt: formatISO(new Date()),
};

type ConversationStore = {
  streamedMsgContent: MessageContent;
  isLoading: boolean;
  isStreaming: boolean;
  chat: ChatResponse | null;
  conversationId: string;
  messages: MessageContent[];
  token: string;
  messageLoading: boolean;
  chatMode: "live_chat_agent" | "bot";
  setChatMode: (mode: "live_chat_agent" | "bot") => void;
  setMessageLoading: (loading: boolean) => void;
  setSocketErrorMsg: (error: string | null) => void;
  socketErrorMsg: string | null;
  setMessages: (messages: MessageContent[]) => void;
  updateMessages: (
    updater: (prev: MessageContent[]) => MessageContent[],
  ) => void;
  updateStreamedMsgContent: (
    updater: (prev: MessageContent) => MessageContent,
  ) => void;
  setStreamedMsgContent: (streamedContent: MessageContent) => void;
  setIsStreaming: (isStreaming: boolean) => void;
  setIsLoading: (loading: boolean) => void;
  setChat: (chats: ChatResponse) => void;
  updateChat: (
    updater: (prev: ChatResponse | null) => ChatResponse | null,
  ) => void;
  setConversationId: (id: string) => void;
  setToken: (token: string) => void;
};

export const useGlobalStore = create<ConversationStore>((set) => ({
  streamedMsgContent: defaultMessageContent,
  isStreaming: false,
  isLoading: false,
  chat: null,
  conversationId: "",
  chatHistory: null,
  token: "",
  chatMode: "bot",
  setChatMode: (mode) => set(() => ({ chatMode: mode })),
  socketErrorMsg: "",
  setSocketErrorMsg: (error) => set(() => ({ socketErrorMsg: error })),
  messages: [],
  messageLoading: false,
  setMessageLoading: (loading) => set(() => ({ messageLoading: loading })),
  setMessages: (messages) => set(() => ({ messages })),
  updateMessages: (updater) =>
    set((state) => ({ messages: updater(state.messages) })),
  updateStreamedMsgContent: (updater) =>
    set((state) => ({ streamedMsgContent: updater(state.streamedMsgContent) })),
  setStreamedMsgContent: (streamedText) =>
    set(() => ({ streamedMsgContent: streamedText })),
  setIsStreaming: (isStreaming) => set(() => ({ isStreaming })),
  setIsLoading: (loading) => set(() => ({ isLoading: loading })),
  setChat: (chat) => set(() => ({ chat: chat })),
  setConversationId: (id) => set(() => ({ conversationId: id })),
  setToken: (token) => set(() => ({ token })),
  updateChat: (updater) => set((state) => ({ chat: updater(state.chat) })),
}));
